/* eslint-disable */
import { Component, Input } from '@angular/core';
import { IconImports } from '@core/modules/components/icon/icon.imports';

@Component({
  selector: 'svg-icon',
  standalone: true,
  templateUrl: './icon.component.html',
  styles: [
    `
      .icon {
        display: inline-block;
        vertical-align: top;
        fill: currentColor;
      }
    `,
  ],
  imports: IconImports,
})
export class SvgIcon {
  @Input() public size: number = 16;
  @Input() public name: string = '';

  constructor() {}
}
